import BranchTypes from './branch.types';

// Create Branch Actions
export const createBranchStart = (data: any) => {
	const action = {
		type: BranchTypes.CREATE_BRANCH_START,
		payload: data,
	};
	return action;
};

export const createBranchSuccess = (data: any) => {
	return {
		type: BranchTypes.CREATE_BRANCH_SUCCESS,
		payload: data,
	};
};

export const createBranchFailure = (error: unknown) => {
	return {
		type: BranchTypes.CREATE_BRANCH_FAILURE,
		payload: error,
	};
};

// Update Branch Actions
export const updateBranchStart = (data: any) => {
	return {
		type: BranchTypes.UPDATE_BRANCH_START,
		payload: data,
	};
};

export const updateBranchSuccess = (data: any) => {
	return {
		type: BranchTypes.UPDATE_BRANCH_SUCCESS,
		payload: data,
	};
};

export const updateBranchFailure = (error: unknown) => {
	return {
		type: BranchTypes.UPDATE_BRANCH_FAILURE,
		payload: error,
	};
};

// Get Branches By Organisation Actions
export const getBranchesByOrganisationStart = (data: any) => {
	return {
		type: BranchTypes.GET_BRANCHES_BY_ORGANISATION_START,
		payload: data,
	};
};

export const getBranchesByOrganisationSuccess = (data: any) => {
	return {
		type: BranchTypes.GET_BRANCHES_BY_ORGANISATION_SUCCESS,
		payload: data,
	};
};

export const getBranchesByOrganisationFailure = (error: unknown) => {
	return {
		type: BranchTypes.GET_BRANCHES_BY_ORGANISATION_FAILURE,
		payload: error,
	};
};

export const getBranchByIdStart = (data: any) => {
	return {
		type: BranchTypes.GET_BRANCH_BY_ID_START,
		payload: data,
	};
};

export const getBranchByIdSuccess = (data: any) => {
	return {
		type: BranchTypes.GET_BRANCH_BY_ID_SUCCESS,
		payload: data,
	};
};

export const getBranchByIdFailure = (error: unknown) => {
	return {
		type: BranchTypes.GET_BRANCH_BY_ID_FAILURE,
		payload: error,
	};
};
